module.exports = __webpack_public_path__ + "img/facebook.8bad2434.svg";